import 'application/src/scss/landingpage/feature/price-charts.scss';

import * as basicLightbox from 'basiclightbox';

window.addEventListener('DOMContentLoaded', _ => {

  // lightbox
  [...document.querySelectorAll('.lightbox')].map(element => {
    const instance = basicLightbox.create(`<img src="${element.src}" alt="">`);
    element.addEventListener('click', e => instance.show());
  });
})